import {
  CPSConfig,
  CPSConfigFunctionnality,
  IProduct,
  IProductFunctionnality,
  OTAUpdateProperty,
  ProductTuto,
} from '../IProduct';
import { P0003601, P0003601Data } from './P0003601';
import { Pool } from '../../../../apis/pool.api';
import { EventProductFunctionnalityEnum } from '../../../../apis/poolEvent.api';
import { environment } from '../../../../../environments/environment';

export class P00046 extends IProduct {
  override deviceTableIndex: number = 4;

  override modelIdentifier?: string = 'P00046';

  override dataIdentifier?: string = 'P00046';

  override manufacturerName?: string = 'ACWA';

  data: P0003601Data = new P0003601Data();

  getProductSmallIllustration(): any {
    return '/assets/ecosystem/images/products/P00046/smallProduct.png';
  }

  getProductIllustration(): any {
    return '/assets/ecosystem/images/products/P00046/product.png';
  }

  getProductImage(): any {
    return '/assets/ecosystem/images/products/P00046/product.png';
  }

  getProductKey(): string {
    return this.modelIdentifier!;
  }

  getProductDeviceTableFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.master?.deviceTable?.P00046;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductDataFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.P00046?.data;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductTuto(): ProductTuto {
    return {
      hasHelp: true,
      helpTitle: 'P00046.tuto.installation.help.title',
      helpSlides: [
        'P00046.tuto.installation.help.1',
        'P00046.tuto.installation.help.2',
        'P00046.tuto.installation.help.3',
        'P00046.tuto.installation.help.4',
      ],
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00046/installation-1.png',
            dark: '/assets/ecosystem/images/products/P00046/installation-1_dark.png',
          },
          text: 'P00046.tuto.installation.page1',
        },
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00046/installation-2.png',
            dark: '/assets/ecosystem/images/products/P00046/installation-2_dark.png',
          },
          text: 'P00046.tuto.installation.page2',
        },
      ],
    };
  }

  getUpdateTuto(): ProductTuto {
    return {
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00046/installation-1.png',
            dark: '/assets/ecosystem/images/products/P00046/installation-1_dark.png',
          },
          text: 'P00046.tuto.update.page1',
        },
        {
          image: {
            light: '/assets/ecosystem/images/products/P00046/update-2.png',
            dark: '/assets/ecosystem/images/products/P00046/update-2_dark.png',
          },
          text: 'P00046.tuto.update.page2',
        },
      ],
    };
  }

  getCPSConfig(): CPSConfig | null {
    return new P0003601().getCPSConfig();
  }

  getEventProductFunctionalities(): EventProductFunctionnalityEnum[] {
    return new P0003601().getEventProductFunctionalities();
  }

  getCPSConfigByFonctionnality(
    functionnality: IProductFunctionnality,
  ): CPSConfigFunctionnality | null {
    return new P0003601().getCPSConfigByFonctionnality(functionnality);
  }

  getPropertyForOTAUpdate(): OTAUpdateProperty | null {
    return new P0003601().getPropertyForOTAUpdate();
  }

  getMinimumFirmwareVersionForBleUpdate(): number | null {
    return 14;
  }

  needConfiguration(pool: Pool): boolean {
    return this.getProductDataFromPool(pool).fvsIConfigurationProduit !== 1;
  }

  getProductVideoURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_1.mp4'
    );
  }

  getProductVideoChapterURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_1.csv'
    );
  }
}
